// Legacy
const slideTypes = [
  {
    name: 'True or False',
    icon: 'fas fa-tasks',
    type: 'hackathon-slide',
    slideType: 'true-or-false',
    desc: 'Swipe through statements and pick True or False',
    label: 'Quiz',
    ahaIcon: 'pick-answer',
    ahaIconWhite: 'pick-answer-w',
    preview: 'pickAnswer',
    canvasUrl: 'http://192.168.1.57:3000/present',
    editorUrl: 'http://192.168.1.57:3000/edit',
    audienceUrl: 'http://192.168.1.57:3000/join',
  },
  {
    name: 'Quiz Hackathon',
    icon: 'fas fa-tasks',
    type: 'hackathon-slide',
    slideType: 'hackathon',
    desc: 'Ask a quiz question and write the options. Participants try to choose the correct answer to score points.',
    label: 'Quiz',
    ahaIcon: 'pick-answer',
    ahaIconWhite: 'pick-answer-w',
    preview: 'pickAnswer',
    videoTutorialUrl: 'https://www.youtube.com/embed/BfOV2Rd9soY',
    canvasUrl: 'http://172.20.10.4:3002/present',
    editorUrl: 'http://172.20.10.4:3002/edit',
    audienceUrl: 'http://172.20.10.4:3002/join',
  },
  {
    name: 'Countdown Timer',
    icon: 'fas fa-hourglass-half',
    type: 'hackathon-slide',
    slideType: 'countdownTimer',
    desc: 'Display a customizable countdown timer with title/message for sessions and activities.',
    label: 'Timer',
    ahaIcon: 'pick-answer',
    ahaIconWhite: 'pick-answer-w',
    preview: 'pickAnswer',
    videoTutorialUrl: 'https://www.youtube.com/embed/BfOV2Rd9soY',
    canvasUrl: 'https://huong-ahaslides.ngrok.app/present',
    editorUrl: 'https://huong-ahaslides.ngrok.app/edit',
    audienceUrl: 'https://huong-ahaslides.ngrok.app/join',
  },
  {
    name: 'Walking Question',
    icon: 'fas fa-tasks',
    type: 'hackathon-slide',
    slideType: 'hackathon-walking-question',
    desc: 'Participants to submit question and peer answer for other.',
    label: 'Quiz',
    ahaIcon: 'pick-answer',
    ahaIconWhite: 'pick-answer-w',
    preview: 'pickAnswer',
    videoTutorialUrl: 'https://www.youtube.com/embed/BfOV2Rd9soY',
    canvasUrl: 'https://don-ahaslides.ngrok.app/presenter',
    editorUrl: 'https://don-ahaslides.ngrok.app/editor',
    audienceUrl: 'https://don-ahaslides.ngrok.app/audience',
  },
  {
    name: 'Random Assignments',
    icon: 'fas fa-tasks',
    type: 'hackathon-slide',
    slideType: 'randomAssignments',
    desc: 'Pick your box and open it to reveal a surprise.',
    label: 'Quiz',
    ahaIcon: 'pick-answer',
    ahaIconWhite: 'pick-answer-w',
    preview: 'pickAnswer',
    videoTutorialUrl: 'https://www.youtube.com/embed/BfOV2Rd9soY',
    canvasUrl: 'http://192.168.1.36:5173/present',
    editorUrl: 'http://192.168.1.36:5173/edit',
    audienceUrl: 'http://192.168.1.36:5173/join',
  },
  {
    name: 'Draw',
    icon: 'fas fa-tasks',
    type: 'hackathon-slide',
    slideType: 'hackathon-draw',
    desc: 'Participants draw a picture to find the final answer.',
    label: 'Quiz',
    ahaIcon: 'pick-answer',
    ahaIconWhite: 'pick-answer-w',
    preview: 'pickAnswer',
    videoTutorialUrl: 'https://www.youtube.com/embed/BfOV2Rd9soY',
    canvasUrl: 'https://duncan.ngrok.app/present',
    editorUrl: 'https//duncan.ngrok.app/edit',
    audienceUrl: 'https://duncan.ngrok.app/audience',
  },
  {
    name: 'A Deck Of Cards',
    icon: 'fas fa-tasks',
    type: 'hackathon-slide',
    slideType: 'hackathon-deck-of-cards',
    desc: 'Shuffle a deck of cards and let participants pick one card.',
    label: 'Quiz',
    ahaIcon: 'pick-answer',
    ahaIconWhite: 'pick-answer-w',
    preview: 'pickAnswer',
    videoTutorialUrl: 'https://www.youtube.com/embed/BfOV2Rd9soY',
    canvasUrl: 'https://192.168.1.91/present',
    editorUrl: 'https://192.168.1.91/edit',
    audienceUrl: 'https://192.168.1.91/audience',
  },

  {
    name: 'Ranking',
    icon: 'fas fa-tasks',
    type: 'ranking',
    slideType: 'hackathon-pin-on-image',
    desc: 'Participants must pin on an image to find the final answer.',
    label: 'Quiz',
    ahaIcon: 'pick-answer',
    ahaIconWhite: 'pick-answer-w',
    preview: 'pickAnswer',
    videoTutorialUrl: 'https://www.youtube.com/embed/BfOV2Rd9soY',
    plugin: true,
  },

  {
    name: 'Pin On Image',
    icon: 'fas fa-tasks',
    type: 'pinOnImage',
    slideType: 'hackathon-pin-on-image',
    desc: 'Participants must pin on an image to find the final answer.',
    label: 'Quiz',
    ahaIcon: 'pick-answer',
    ahaIconWhite: 'pick-answer-w',
    preview: 'pickAnswer',
    videoTutorialUrl: 'https://www.youtube.com/embed/BfOV2Rd9soY',
    plugin: true,
  },
  {
    name: 'Idea Board',
    icon: 'fas fa-tasks',
    type: 'ideaBoard',
    slideType: 'hackathon-pin-on-image',
    desc: 'Participants must pin on an image to find the final answer.',
    label: 'Quiz',
    ahaIcon: 'pick-answer',
    ahaIconWhite: 'pick-answer-w',
    preview: 'pickAnswer',
    videoTutorialUrl: 'https://www.youtube.com/embed/BfOV2Rd9soY',
    plugin: true,
  },
  {
    name: 'Sample Slide',
    icon: 'fas fa-tasks',
    type: 'sample-slide',
    slideType: 'hackathon-pin-on-image',
    desc: 'Participants must pin on an image to find the final answer.',
    label: 'Quiz',
    ahaIcon: 'pick-answer',
    ahaIconWhite: 'pick-answer-w',
    preview: 'pickAnswer',
    videoTutorialUrl: 'https://www.youtube.com/embed/BfOV2Rd9soY',
    plugin: true,
    setting: {
      enableFullScreen: true,
      enableAudienceJoinPresentation: true,
    },
  },
  {
    name: 'Survey',
    type: 'survey',
    slideType: 'survey',
    desc: 'Run a multi-question survey on the slide. Audience taps in on their device to respond.',
    label: 'Content',
    // Icons follow Design System V3 naming, matching the presenter app's
    // slideTypes.js entry for `type: 'survey'` (AHA-42907). storybook-app
    // 2.3.13+ ships `survey-v3-light` (#4A4A4A stroke for light bg) and
    // `survey-v3-dark` (#FDFDFD for dark).
    ahaIcon: 'survey-v3-light',
    ahaIconWhite: 'survey-v3-dark',
    preview: 'survey',
    plugin: true,
    // Survey audience renders edge-to-edge (its iframe reports
    // onHeightChange(null) to fill the slot — see PR #5 in
    // slide-plugin-built-by-ahasliders). Without enableFullScreen
    // SlidePluginContent applies `height: 100%` to a container with
    // no fixed height, which collapses the iframe to 0. Mirrors the
    // diagram entry below.
    setting: {
      enableFullScreen: true,
    },
  },
  {
    // Content V2 (AHA-42560) — successor to the freestyle "Content" slide.
    // Wire-level `type: 'content-v2'` matches the slide-plugin route
    // (`${slidePluginUrl}/content-v2/{canvas|settings}/{slideId}`) and the
    // presenter-app entry in PR #4387. Mirrors the same registration
    // pattern the Survey rollout used (PR #775 / AHA-42639).
    //
    // Without this entry, `isShowSlidePlugin` finds no `content-v2` slide
    // type in the audience-side registry and falls back to the legacy
    // `AHA-42142-embed-app` Unleash payload — same failure mode Survey
    // hit pre-#775. Registering natively makes audience rendering
    // independent of the embed-app payload.
    //
    // No flag check on audience side — other plugin types (diagram,
    // ideaBoard, pinOnImage, survey) follow the same pattern, with
    // flag-gating handled at slide-creation time in presenter
    // (`AHA-42560-content-v2-slide`).
    //
    // TODO(storybook): no dedicated `content-v2-*` SVG pair yet, so we
    // reuse the existing `content-v3-*` icons (matches presenter PR
    // #4387). Replace once the designers ship the v2 icon set in
    // stpancras-storybook-app.
    name: 'Content v2',
    type: 'content-v2',
    slideType: 'content-v2',
    desc: 'Compose a slide with text, images, shapes, and smart layouts on a free-form surface. The next-generation content slide.',
    label: 'Content',
    ahaIcon: 'content-v3-light',
    ahaIconWhite: 'content-v3-dark',
    preview: 'content',
    plugin: true,
    // Content V2 renders edge-to-edge — its iframe reports
    // onHeightChange(null) to fill the slot. Without enableFullScreen,
    // SlidePluginContent applies `height: 100%` to a container with no
    // fixed height, which collapses the iframe to 0. Mirrors the
    // Survey / Diagram entries above and below.
    setting: {
      enableFullScreen: true,
    },
  },
  {
    name: 'Diagram',
    type: 'diagram',
    slideType: 'diagram',
    desc: 'Visualise structured information — flow diagrams, hierarchies, charts, word clouds, comparisons, timelines.',
    label: 'Content',
    // Icons follow Design System V3 naming, matching the presenter app entry
    // for diagram (AHA-42445, PR #4235): `-v3-light` is the #4A4A4A stroke
    // variant for light backgrounds, `-v3-dark` is #FDFDFD for dark.
    ahaIcon: 'diagram-v3-light',
    ahaIconWhite: 'diagram-v3-dark',
    preview: 'diagram',
    plugin: true,
    // Diagram renders edge-to-edge (its iframe reports onHeightChange(null)
    // to fill the slot). Without `enableFullScreen`, SlidePluginContent
    // applies `height: 100%` to a container with no fixed height, which
    // collapses the iframe to 0. Mirrors the presenter slide-type entry.
    setting: {
      enableFullScreen: true,
    },
  },
]

export default slideTypes
